import { makeStyles } from 'tss-react/mui';

const useStylesNavigationContentItem: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  navigationContentItem: {
    paddingLeft: '25px !important',
    color: `${theme.palette.common.white} !important`,
  },
  navigationContentItemActive: {
    color: `${theme.palette.secondary.main} !important`,
  },
  navigationContentItemIcon: {
    minWidth: '35px !important',
    marginTop: -3,
  },
  navigationContentItemIconActive: {
    color: `${theme.palette.secondary.main} !important`,
  },
}));

export default useStylesNavigationContentItem;
